import { ConfirmRemoveFriend, CONFIRM_REMOVE_FRIEND_DIALOG } from "common/dialogs/ConfirmRemoveFriend";
import { FriendInteractionsButtons } from "common/FriendInteractionsButtons";
import { Icon } from "common/Icon";
import { ProfileImg } from "common/ProfileImg";
import { Card } from "common/styleguide/Card";
import { CTA } from "common/styleguide/CTA";
import { fourOhFourMessages } from "features/pages/FourOhFour";
import { deserializeUser } from "lib/api/records";
import fetchJSON from "lib/fetchJSON";
import { commonCTAs, Msg } from "lib/localization";
import React from "react";
import { defineMessages } from "react-intl";
import { useHistory } from "react-router-dom";
import styles from "./PrivateUserPage.scss";

const messages = defineMessages({
  privateFriend: {
    id: "PrivateUserPage.privateFriend",
    defaultMessage: `
      You are friends with {nameString}, but their profile is currently <em>Private</em>.
      {br}
      If {nameString} changes their profile privacy setting, their profile will become visible.
    `,
  },
  thisUser: {
    id: "PrivateUserPage.thisUser",
    defaultMessage: "this user",
  },
  friendsOnly: {
    id: "PrivateUserPage.friendsOnly",
    defaultMessage: `
      The profile you are trying to view is set to <em>Friends Only</em>.
      {br}
      Please request to add them as a friend to view their profile.
    `, // TODO update this language to reflect follows
  },
});

const PrivateUserPage = ({ top, middle, buttons }) => (
  <div className={styles.privatePage}>
    <Card className={styles.card}>
      {top}
      {middle}
      <div className={styles.buttons}>{buttons}</div>
    </Card>
  </div>
);

export const PrivateUserProfilePage = () => {
  const history = useHistory();
  return (
    <PrivateUserPage
      top={
        <div className={styles.icon}>
          <Icon i="404" size={84} />
        </div>
      }
      middle={
        <>
          <h2>
            <Msg m={fourOhFourMessages.header} />
          </h2>
          <p style={{ marginBottom: "20px" }}>
            <Msg m={fourOhFourMessages.message} />
          </p>
        </>
      }
      buttons={
        <>
          <CTA inline margins={false} href="https://ridewithgps.zendesk.com/hc/en-us/requests/new">
            <Msg m={fourOhFourMessages.submit} />
          </CTA>
          <CTA inline margins={false} link onClick={() => history.goBack()}>
            <Msg m={commonCTAs.goBack} />
          </CTA>
        </>
      }
    />
  );
};

export class FriendsOnlyUserProfilePage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      userLoaded: false,
      modal: null,
    };
  }

  componentDidMount() {
    const { userId } = this.props;

    fetchJSON(`/users/${userId}/private_user_show.json`).then(({ user }) => {
      this.setState({ user: deserializeUser(user), userLoaded: true });
    });
  }

  showDialog = (dialog) => {
    this.setState({ modal: dialog });
  };

  clearDialog = () => {
    this.setState({ modal: null });
  };

  render() {
    const { user, userLoaded, modal } = this.state;
    const { userIsFriend } = this.props;

    const body = userIsFriend ? (
      <div>
        <Msg
          m={messages.privateFriend}
          values={{
            nameString: user?.name ?? <Msg m={messages.thisUser} />,
            em: (...c) => <em>{c}</em>,
            br: <br />,
          }}
        />
      </div>
    ) : (
      <div>
        <Msg
          m={messages.friendsOnly}
          values={{
            em: (...c) => <em>{c}</em>,
            br: <br />,
          }}
        />
      </div>
    );

    return (
      <>
        {modal === CONFIRM_REMOVE_FRIEND_DIALOG && (
          <ConfirmRemoveFriend toUnfriend={user} onRequestClose={this.clearDialog} />
        )}
        <PrivateUserPage
          top={
            <div className={styles.icon}>
              <ProfileImg large user={user} />
            </div>
          }
          middle={
            <>
              <h2>{user && user.name}</h2>
              {body}
            </>
          }
          buttons={
            userLoaded && (
              <FriendInteractionsButtons
                user={user}
                privateUser
                userIsFriend={userIsFriend}
                showDialog={this.showDialog}
              />
            )
          }
        />
      </>
    );
  }
}
